import { PRODUCT_KEY } from "@opengov/components-nav-bar";
import { Entitlement, EntitlementProductKey, GlobalNavApplicationId } from "../types";

export const APPS_REQUIRE_ENTITLEMENTS: GlobalNavApplicationId[] = [
  "dashboard",
  "reports",
  "reportsClassic",
  "reportsNextGen",
  "transparency",
  "data",
  "stories",
  "performance",
  "workflows",
];

export type GetActiveProductKeyParams = {
  activeAppKey: GlobalNavApplicationId;
  entitlements: Entitlement[] | undefined;
  entitlementsRequired?: boolean;
};

export const getActiveProductKey = ({
  activeAppKey,
  entitlements,
  entitlementsRequired,
}: GetActiveProductKeyParams): PRODUCT_KEY | undefined => {
  const noRequiredEntitlements = entitlementsRequired && !entitlements;
  switch (activeAppKey) {
    case "performance":
    case "performancePublicServicePlatform":
      if (noRequiredEntitlements) return "budget";
      if (entitlements?.some((entitlement) => entitlement.entitlementProductKey === EntitlementProductKey.Budget)) {
        return "budget";
      }
      return "perfmgmt";
    case "budgets":
    case "workforce":
    case "initiatives":
      return "budget";
    case "reportsPublicServicePlatform":
    case "dataPublicServicePlatform":
      return "reporting";
    case "network":
    case "dashboard":
    case "reports":
    case "reportsClassic":
    case "reportsNextGen":
    case "transparency":
    case "data":
    case "stories":
    case "workflows":
      if (noRequiredEntitlements) return undefined;
      if (entitlements?.some((entitlement) => entitlement.entitlementProductKey === EntitlementProductKey.Budget)) {
        return "budget";
      } else if (
        entitlements?.some((entitlement) => entitlement.entitlementProductKey === EntitlementProductKey.Performance)
      ) {
        return "perfmgmt";
      } else {
        return "reporting";
      }
    default:
      return "budget";
  }
};
